import { useEffect, useCallback } from 'react';

export function useDebounce(effect, dependencies = [], delay = 800) {
  const callback = useCallback(effect, dependencies);

  useEffect(() => {
    const timeout = setTimeout(callback, delay);
    return () => clearTimeout(timeout);
  }, [callback, delay]);
}
